module.exports = __webpack_public_path__ + "static/media/navigation-tabletWithLogoVW.3274b6d8.png";